import React from 'react';
import Text from 'components/Core/Text';
import { CareersPerksSection } from './styles';

const CareersPerks = ({
  perkLifestyle,
  perkHealth,
  perkFamily,
  perkFinance,
  perkBeach,
  perkCommunity,
  ...otherProps
}) => (
  <CareersPerksSection {...otherProps}>
    <Text type={'h2'} alignDesktop={'center'} size={'28px'} className="careers--underlined-heading">
      Perks
    </Text>
    <div className="careers--perks-row">
      <div className="careers--perk">
        <img src={perkHealth} />
        <Text type={'h5'} alignDesktop={'center'} size={'25px'} className="careers--perk-heading">
          Health
        </Text>
        <Text type={'p'} alignDesktop={'center'} className="careers--perk-body">
          Our healthcare plans provide comprehensive care. We cover 100% of individual medical,
          dental, and vision coverage.
        </Text>
      </div>
      <div className="careers--perk">
        <img src={perkFinance} />
        <Text type={'h5'} alignDesktop={'center'} size={'25px'} className="careers--perk-heading">
          Financial Wellbeing
        </Text>
        <Text type={'p'} alignDesktop={'center'} className="careers--perk-body">
          Work on your financial goals with 401(k) match, a Certified Financial Planner, and company
          HSA contributions.
        </Text>
      </div>
      <div className="careers--perk">
        <img src={perkFamily} />
        <Text type={'h5'} alignDesktop={'center'} size={'25px'} className="careers--perk-heading">
          Family Matters
        </Text>
        <Text type={'p'} alignDesktop={'center'} className="careers--perk-body">
          A great place to start or grow your family with programs to support all paths to
          parenthood.
        </Text>
      </div>
      <div className="careers--perk">
        <img src={perkBeach} />
        <Text type={'h5'} alignDesktop={'center'} size={'25px'} className="careers--perk-heading">
          Time Away from Work
        </Text>
        <Text type={'p'} alignDesktop={'center'} className="careers--perk-body">
          To deliver your best, you need to be at your best. Flexible time off and parental leave
          lets you make time for what matters.
        </Text>
      </div>
      <div className="careers--perk">
        <img src={perkLifestyle} />
        <Text type={'h5'} alignDesktop={'center'} size={'25px'} className="careers--perk-heading">
          Balancing Work & Life
        </Text>
        <Text type={'p'} alignDesktop={'center'} className="careers--perk-body">
          Supportive benefits when you need them; mental health, care coordination, pet insurance,
          legal benefits.
        </Text>
      </div>
      <div className="careers--perk">
        <img src={perkCommunity} />
        <Text type={'h5'} alignDesktop={'center'} size={'25px'} className="careers--perk-heading">
          Recognition
        </Text>
        <Text type={'p'} alignDesktop={'center'} className="careers--perk-body">
          Whether it’s peer-to-peer, top down, or compensation, we take recognition seriously.
        </Text>
      </div>
    </div>
  </CareersPerksSection>
);

export default CareersPerks;
